// extracted by mini-css-extract-plugin
module.exports = {"tags":"propertyCardTags_tags__WVPf1","bottomTags":"propertyCardTags_bottomTags__3PRfM","hidden":"propertyCardTags_hidden__38yj_","tag":"propertyCardTags_tag__2EufI","featuredTag":"propertyCardTags_featuredTag__tv-AC","typeText":"propertyCardTags_typeText__1c8Rj","type":"propertyCardTags_type__1749u"};
    if(module.hot) {
      // 1790670288092
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  